module.exports = __webpack_public_path__ + "img/1.a595d351.jpg";